import React from 'react'
import NProgress from 'react-nprogress'
import axios from 'axios'
import PropTypes from 'prop-types'

import JsonToQuery from 'Utils/JsonToQuery'
import Types from './Types'
import RecentContacts from './RecentContacts'
import RecentContactsEmpty from './RecentContactsEmpty'

class FilterSidebar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      contacts: {
        data: [],
        meta: {
          totalCount: 0,
          currentPage: 1,
        },
      },
    }

    this.onFetchConversationContactsSuccess = this.onFetchConversationContactsSuccess.bind(this)
    this.onFetchConversationContactsFailure = this.onFetchConversationContactsFailure.bind(this)
    this.loadMoreContacts = this.loadMoreContacts.bind(this)
    this.searchContacts = this.searchContacts.bind(this)
  }

  fetchConversationContacts(page = 1, query = '') {
    if (this._isMounted) {
      NProgress.start()

      axios.get(`/api/internal/conversations/contacts?${JsonToQuery({ page, query })}`)
        .then(this.onFetchConversationContactsSuccess)
        .catch(this.onFetchConversationContactsFailure)
    }
  }

  onFetchConversationContactsSuccess(response) {
    NProgress.done()

    const newData = response.data.meta.currentPage === 1
      ? response.data.data
      : this.state.contacts.data.concat(response.data.data)

    return this.setState({
      didFetchData: true,
      contacts: {
        data: newData,
        meta: response.data.meta,
      },
    })
  }

  onFetchConversationContactsFailure(xhr, status, err) {
    NProgress.done()
  }

  componentDidMount() {
    this._isMounted = true
    this.fetchConversationContacts()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  loadMoreContacts() {
    this.fetchConversationContacts(this.state.contacts.meta.currentPage + 1)
  }

  searchContacts(query) {
    this.fetchConversationContacts(1, query)
  }

  render() {
    return (
      <div className="conversations-sidebar__content">
        <div className="conversations-sidebar__area">
          <div className="conversations-sidebar__header">
            <span className="section__title">Conversation Type</span>
          </div>
          <Types
            aggregates={this.props.aggregates.type}
            selectedType={this.props.selectedType}
            onTypeChange={this.props.onTypeChange}
          />
        </div>
        <div className="conversations-sidebar__area">
          <div className="conversations-sidebar__header">
            <span className="section__title">Recent Contacts</span>
          </div>
          <div className="conversations-sidebar__section">
            {
              this.state.contacts.meta.totalCount > 0
                ? (
                  <RecentContacts
                    aggregates={this.props.aggregates}
                    contacts={this.state.contacts}
                    onLoadMore={this.loadMoreContacts}
                    onSearchQueryChange={this.searchContacts}
                    onUsernameChange={this.props.onUsernameChange}
                    selectedUsername={this.props.selectedUsername}
                  />
                )
                : <RecentContactsEmpty onSearchQueryChange={this.searchContacts} />
            }
          </div>
        </div>
      </div>
    )
  }
}

FilterSidebar.propTypes = {
  aggregates: PropTypes.shape({
    type: PropTypes.shape({
      all: PropTypes.number,
      personal: PropTypes.number,
      cgtraderSupport: PropTypes.number,
      offer: PropTypes.number,
      jobApplication: PropTypes.number,
    }),
    status: PropTypes.shape({
      active: PropTypes.number,
      unread: PropTypes.number,
      unanswered: PropTypes.number,
      archived: PropTypes.number,
    }),
  }).isRequired,
  onTypeChange: PropTypes.func.isRequired,
  onUsernameChange: PropTypes.func.isRequired,
  selectedUsername: PropTypes.string,
}

RecentContacts.defaultPropTypes = {
  selectedUsername: '',
}

export default FilterSidebar
